import { strings } from "@/constants";
import type { CompanyType } from "@/types";
import { formatDateHandler } from "@/utils";

const fieldRowClass = `
    flex
    items-center
    justify-between
    gap-2
    px-4
    py-3
    sm:gap-4
    sm:px-6
`;

export const CompanyDetailFields = ({ company }: { company: CompanyType }) => (
    <dl className="divide-y divide-gray-100">
        <div className={fieldRowClass}>
            <dt className="text-sm text-text-secondary">{strings.profile.nameLabel}</dt>
            <dd className="text-sm font-medium text-text-primary">{company.name || strings.profile.notAvailable}</dd>
        </div>
        <div className={fieldRowClass}>
            <dt className="text-sm text-text-secondary">{strings.profile.phoneLabel}</dt>
            <dd className="text-sm font-medium text-text-primary">{company.phone || strings.profile.notAvailable}</dd>
        </div>
        {company.createdAt && (
            <div className={fieldRowClass}>
                <dt className="text-sm text-text-secondary">{strings.admin.invitedAt}</dt>
                <dd className="text-sm font-medium text-text-primary">{formatDateHandler(company.createdAt)}</dd>
            </div>
        )}
    </dl>
);
